export default "__VITE_ASSET__9UtmCOOC__"